import { render, staticRenderFns } from "./cpxruning.vue?vue&type=template&id=40a9ad5e"
import script from "./cpxruning.vue?vue&type=script&lang=js"
export * from "./cpxruning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports